var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"position-relative overflow-hidden"},[_c('h2',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Residents")]),_c('Table',{attrs:{"config":_vm.filteredConfig,"rows":_vm.residentsList,"total":_vm.residentsTotal},scopedSlots:_vm._u([{key:"facility",fn:function(ref){
var item = ref.item;
return [_c('FacilityLabel',{attrs:{"facility":item.facility}})]}},{key:"resident",fn:function(ref){
var item = ref.item;
return [_c('resident-label',{attrs:{"resident":item}})]}},{key:"status",fn:function(ref){
var item = ref.item;
return [_c('StatusResident',{attrs:{"status":item.status}})]}},{key:"balance",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"font-weight-semi-bold"},[_vm._v(_vm._s(_vm._f("currency")(item.balance ? item.balance : 0)))])]}},{key:"stopSendingStatements",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.stopSendingStatements ? 'Yes' : 'No')+" ")]}},{key:"excludeFromCollections",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.excludeFromCollections ? 'Yes' : 'No')+" ")]}},{key:"lastUpdate",fn:function(ref){
var item = ref.item;
return [_c('DateTimeLabel',{attrs:{"date":item.updatedAt,"use-user-timezone":""}})]}},{key:"actions",fn:function(ref){
var item = ref.item;
return undefined}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }